import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import medicGeekApi from "../../../config/axiosConfig";

const Cie10List = ({ currentForm }) => {
  const [cie10s, setCie10s] = useState([]);
  const [showForm] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const cie10sPerPage = 15;
  const [selectedCie10Local, setSelectedCie10Local] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [displayedPages, setDisplayedPages] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Estado para mostrar el esqueleto
  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cachedData = JSON.parse(localStorage.getItem("cie10s")); // Obtener datos del caché
        const cacheTime = localStorage.getItem("cie10sCacheTime");
        const now = new Date();

        // Si existe el caché y tiene menos de 1 hora (3600000 ms), lo usamos
        if (cachedData && cacheTime && now - new Date(cacheTime) < 3600000) {
          setCie10s(cachedData);
          setIsLoading(false);
        } else {
          // Si no hay caché o es antiguo, obtenemos los datos del endpoint
          const response = await medicGeekApi.get(
            `/cie10s?search=${searchTerm}`
          );
          const sortedCie10 = response.data.sort((a, b) => a.code - b.code);

          // Guardar los datos en el caché con una marca de tiempo
          localStorage.setItem("cie10s", JSON.stringify(sortedCie10));
          localStorage.setItem("cie10sCacheTime", new Date());

          setCie10s(sortedCie10);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, [searchTerm]);

  const pageCount = Math.ceil(cie10s?.length / cie10sPerPage);

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
    const currentPageGroup = Math.floor(selected / 10);

    if (selected % 10 === 0) {
      // Calcula el número de la primera página del siguiente grupo de 10
      const nextPageGroup = (currentPageGroup + 1) * 10;
      const maxPage = Math.min(pageCount, nextPageGroup);

      const newDisplayedPages = Array.from(
        { length: Math.min(pageCount, maxPage) },
        (_, index) => index + nextPageGroup * 10
      );
      setDisplayedPages(newDisplayedPages);
    }
  };

  const displayedCie10 = cie10s
    .filter((cie10) => {
      return (
        cie10.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
        cie10.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    })
    .slice(pageNumber * cie10sPerPage, (pageNumber + 1) * cie10sPerPage);

  return (

  <div className="pro-container">

    {/* ===================================================== */}
    {/* HEADER */}
    {/* ===================================================== */}

    <div className="pro-header">

      <div className="pro-header-left">

        <h1 className="pro-title">
          CIE-10
        </h1>

        <p className="pro-subtitle">
          Catálogo internacional de diagnósticos médicos
        </p>

      </div>

      <div className="pro-actions w-auto">

        <div className="pro-search">

          <i className="bi bi-search"></i>

          <input
            type="search"
            placeholder="Buscar diagnóstico..."
            value={searchTerm}
            onChange={handleSearchTermChange}
          />

        </div>

      </div>

    </div>

    {/* ===================================================== */}
    {/* TABLE CARD */}
    {/* ===================================================== */}

    <div className="pro-card">

      <div className="table-responsive">

        <table className="table pro-table align-middle">

          <thead>

            <tr>

              <th
                style={{
                  width: "15%",
                }}
              >
                Código
              </th>

              <th>
                Descripción
              </th>

            </tr>

          </thead>

          <tbody>

            {isLoading ? (

              Array.from({ length: 10 }).map((_, index) => (

                <tr key={index}>

                  <td>

                    <div className="skeleton-line"></div>

                  </td>

                  <td>

                    <div className="skeleton-line"></div>

                  </td>

                </tr>

              ))

            ) : displayedCie10.length > 0 ? (

              displayedCie10.map((cie10s) => (

                <tr key={cie10s.code}>

                  <td>

                    <span className="expediente-badge">

                      {cie10s.code}

                    </span>

                  </td>

                  <td>

                    <div
                      className="truncate-text"
                      style={{
                        fontWeight: 600,
                        color: "var(--text-primary)",
                      }}
                    >

                      {cie10s.description}

                    </div>

                  </td>

                </tr>

              ))

            ) : (

              <tr>

                <td
                  colSpan="2"
                  className="text-center py-5"
                >

                  <div className="d-flex flex-column align-items-center">

                    <i
                      className="bi bi-search"
                      style={{
                        fontSize: "2rem",
                        color: "#94a3b8",
                      }}
                    ></i>

                    <span
                      className="mt-3"
                      style={{
                        color: "var(--text-secondary)",
                        fontWeight: 600,
                      }}
                    >

                      No se encontraron resultados

                    </span>

                  </div>

                </td>

              </tr>

            )}

          </tbody>

        </table>

      </div>

      {/* ===================================================== */}
      {/* PAGINATION */}
      {/* ===================================================== */}

      <div className="pro-pagination">

        <nav>

          <ul className="pagination modern-pagination">

            {/* INICIO */}

            <li
              className={`page-item ${
                pageNumber === 0
                  ? "disabled"
                  : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: 0,
                  })
                }
              >

                <i className="bi bi-chevron-double-left"></i>

              </span>

            </li>

            {/* ATRAS 10 */}

            <li
              className={`page-item ${
                pageNumber === 0
                  ? "disabled"
                  : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: Math.max(
                      0,
                      pageNumber - 10
                    ),
                  })
                }
              >

                <i className="bi bi-chevron-left"></i>

              </span>

            </li>

            {/* NUMEROS */}

            {Array.from(
              {
                length: Math.min(
                  pageCount,
                  10
                ),
              },
              (_, index) => (

                <li
                  key={index}
                  className={`page-item ${
                    pageNumber === index
                      ? "active"
                      : ""
                  }`}
                >

                  <span
                    className="page-link"
                    onClick={() =>
                      handlePageChange({
                        selected: index,
                      })
                    }
                  >

                    {index + 1}

                  </span>

                </li>

              )
            )}

            {/* SIGUIENTE */}

            <li
              className={`page-item ${
                pageNumber === pageCount - 1
                  ? "disabled"
                  : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: Math.min(
                      pageCount - 1,
                      pageNumber + 10
                    ),
                  })
                }
              >

                <i className="bi bi-chevron-right"></i>

              </span>

            </li>

            {/* FINAL */}

            <li
              className={`page-item ${
                pageNumber === pageCount - 1
                  ? "disabled"
                  : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageCount - 1,
                  })
                }
              >

                <i className="bi bi-chevron-double-right"></i>

              </span>

            </li>

          </ul>

        </nav>

      </div>

    </div>

  </div>

);
};
export default Cie10List;
